import React, { useState } from 'react';
import { Modal, Button, Input } from 'antd';
import { FormItemLabel, ModalTitle } from '../../../components/text/Titles';

type Props = {
  title: string;
  visible: boolean;
  onClose: () => any;
  onSave: (name: string) => any;
};

export const CreateNewDataset = (props: Props) => {
  const { title, visible, onClose, onSave } = props;

  const [name, setName] = useState<string>('');

  const onSubmit = async () => {
    onClose();
    onSave(name);
    setName('');
  };

  const onCancel = async () => {
    onClose();
    setName('');
  };

  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title={<ModalTitle>{title}</ModalTitle>}
      onCancel={onCancel}
      footer={
        <div>
          <Button type="default" onClick={onCancel}>
            Cancel
          </Button>
          <Button style={{ marginLeft: '10px' }} type="primary" onClick={onSubmit} disabled={name === ''}>
            Save
          </Button>
        </div>
      }>
      <FormItemLabel>This process will create a new dataset.</FormItemLabel>
      <Input
        placeholder="Dataset name"
        value={name}
        onChange={e => setName(e.target.value)}
        style={{ margin: '10px 0px 10px 0px' }}
      />
    </Modal>
  );
};
